import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CBORow,
    WB_Published_ModelRow,
    WB_SimulationTypeRow,
    WB_ProductGroupRow,
    WB_UserRow,
    WB_PlanProductGroupRow,
    WB_CustomerRow,
    WB_ModelPredictorRow,
    WB_CBOPredictorRangeRow,
    WB_CBOPredictorRelationshipRow,
    WB_CBOPredictorDiscreteSetRow,
    WB_ModelCoefficientSetRRow,
    WB_SpendFunctionRelationshipRow,
    WB_SimulationInputRow, WB_CBOConstraintRow, WB_CBOInputRelationshipRow
} from "../PA.Core/PAdbSchemaRows";
import {IHaveModel} from "../PA.Model.Core/PA.Model.IF.Aspects";

import {
    esWB_CBO,
    esWB_CBO_Product,
    esWB_CBO_Input_Relationship,
    esWB_CBO_Predictor_Relationship,
    esWB_CBO_Predictor_Range,
    esWB_CBO_Metric,
    esWB_CBO_Constraint,
    esWB_Published_Model,
    esWB_Product_Group,
    esWB_Simulation_Type,
    esWB_User,
    esWB_Simulation_Type_Input_Relationship,
    esWB_Customer,
    esWB_CBO_Predictor_DiscreteSet,
    esWB_Model_Coeff_SetR,
    esWB_Spend_Function_Relationship,
    esWB_Simulation_Input,
    esWB_CBO_Metric_Predictor
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IHaveProductGroups} from "../PA.Core/PA.Core.IF.Aspects";
import {BehaviorSubject} from "rxjs";
import {ModelBO} from "../PA.Model.BusinessObjects/ModelBO";
import {ISimulationModel} from "../PA.Simulation.Core/PA.Simulation.IF.Aspects";
import {ModelCoefficientSetBO} from "../PA.Model.BusinessObjects/ModelCoefficientSetBO";
import {IHaveCBOCalculator} from "../PA.Simulation.Services/CBOServices.IF"
import {ConstraintBasedOptimizerBOValidation} from "./ConstraintBasedOptimizerBOValidation";
import {
    DiscreteSetChangeEvent,
    IConstraintBasedOptimizer, IHaveCBOConstantInputs,
    IHaveSpendMetrics
} from "../PA.Simulation.Core/PA.CBO.IF.Aspects";
import {ICBOCalculator} from "../PA.Simulation.Services/CBOServices.IF";
import {CBOCalculator} from "../PA.Simulation.Services/CBOCalculator";
import {IwbProductCondition} from "../PA.Core/PAdbSchemaRowsIF";
import {PricingEngine} from "../PA.MD.Core/PricingEngine";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {IRefCounter} from "../PA.Concurrency.Core/PA.Concurrency.IF.RefCounter";
import {Subscription} from "rxjs/Subscription";
import {RefCounter} from "../PA.Concurrency.Core/RefCounter";

export interface createNewOptions {
    SimulationTypeId: number,
    PublishedModelId: number
}


export class ConstraintBasedOptimizerBO
    implements
        IBusinessObject,
        IConstraintBasedOptimizer,
        IHaveSpendMetrics,
        IHaveModel,
        IHaveCBOCalculator,
        IHaveProductGroups,
        IHaveCBOConstantInputs
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_CBO: WB_CBORow

    arrModel: ISimulationModel[]

    forwardBuy: string


    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New CBO'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_CBO = null;

        this.arrModel = []
        this.forwardBuy = ""

        this.IHaveProductGroups_init()
        this.IHaveModel_init()
        this.IConstraintBasedOptimizer_init()
        this.IHaveSpendMetrics_init()
        this.IHaveCBOCalculator_init()
        this.IHaveCBOInputs_init()
        this.RefCounter_Init()
        this.ICBOSolver_init()
        // this.IHaveExecutionRows_init()
    }

    get WB_CBO(): WB_CBORow {
        return this.drWB_CBO;
    }

    get bHasForwardBuy(): boolean {
        return !_.isEmpty(this.forwardBuy)
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: createNewOptions): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating CBO");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (self.dbContext == null) {
                let sError = "Unable to determine dbContext for New CBO.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            let typeRow: WB_SimulationTypeRow = undefined
            let modelRow: WB_Published_ModelRow = undefined
            let usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)


            // Create record using dbContext
            self.dbContext.find(esWB_Published_Model, options.PublishedModelId)
                .then((aModelRecord: WB_Published_ModelRow) => {
                    if (_.isEmpty(aModelRecord))
                        return
                    modelRow = aModelRecord
                    return self.dbContext.find(esWB_User, aModelRecord.cif.WB_AUTHUSR_ID_CREATEDBY)
                })
                .then((aUserRow: WB_UserRow) => {
                    modelRow.WB_UserRow_CreatedBy = aUserRow

                    return self.dbContext.findAll(esWB_Simulation_Type, {where: {WB_SIMULATIONM_ID: options.SimulationTypeId}}, {with: [esWB_Simulation_Type_Input_Relationship, esWB_Simulation_Input]})
                })
                .then((arrTypeRecord: WB_SimulationTypeRow[]) => {
                    if (_.isEmpty(arrTypeRecord))
                        return
                    typeRow = arrTypeRecord[0]
                    return self.dbContext.findAll(esWB_Simulation_Input, {
                        WB_SIMULATION_INPUT_ID: {
                            inq: _.map(typeRow.WB_SimulationTypeInputRelationshipRows, aRow => {
                                return aRow.cif.WB_SIMULATION_INPUT_ID
                            })
                        }
                    })
                })
                .then((arrInput: WB_SimulationInputRow[]) => {
                    _.forEach(typeRow.WB_SimulationTypeInputRelationshipRows, aRow => {
                        aRow.WB_SimulationInputRow = _.first(_.filter(arrInput, anInput => anInput.cif.WB_SIMULATION_INPUT_ID == aRow.cif.WB_SIMULATION_INPUT_ID))
                    })
                    return self.dbContext.createRecordWithKey(esWB_CBO)
                })

                .then((newCBORow: WB_CBORow) => {
                    newCBORow.setDefaults();
                    self.drWB_CBO = newCBORow;
                    self.drWB_CBO.cif.WB_PUBLISHED_MODEL_ID = modelRow.cif.WB_PUBLISHED_MODEL_ID
                    self.drWB_CBO.WB_PublishedModelRow = modelRow
                    self.drWB_CBO.cif.WB_SIMULATIONM_ID = typeRow.cif.WB_SIMULATIONM_ID
                    self.drWB_CBO.WB_SimulationTypeRow = typeRow
                    self.dbContext.add(esWB_CBO, newCBORow);
                    self.drWB_CBO.WB_UserRow_CreatedBy = usrContext.User

                    self.Identity.setAll(self.WB_CBO.cif.WB_CBO_ID, self.WB_CBO.cif.CBO_ID, self.WB_CBO.cif.CBO_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_CBO, 'WB_CBO_ID', 'CBO_ID', 'CBO_NAME');

                    return self._AfterBoLoadCompleteInternal()
                })
                .then(() => {
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })
        });

        return this._OnLoadComplete;
    }

    Load(anId: number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                let sError = "CBO Type already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for CBO.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = ConstraintBasedOptimizerBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = ConstraintBasedOptimizerBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function () {
                    let newCBORow: any = recordResolver.get(esWB_CBO, anId);

                    if (_.isEmpty(newCBORow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_CBO = newCBORow;
                    self.Identity.setAll(self.WB_CBO.cif.WB_CBO_ID, self.WB_CBO.cif.CBO_ID, self.WB_CBO.cif.CBO_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_CBO, 'WB_CBO_ID', 'CBO_ID', 'CBO_NAME');
                    return self._AfterBoLoadCompleteInternal()
                })
                .then(() => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.finish();
                    resolve(self)
                })
                .catch((err: any) => {
                    self._OnLoadComplete = undefined;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                    return
                });

        });

        return this._OnLoadComplete;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        self.LoadProgressProvider.setProgressMessage('CBO.Load', 'Processing CBO Loaded Data');

        await self.OnIHaveModelLoaded
        await self.OnIHaveModelCoefficientSetLoaded
        await self.IConstraintBasedOptimizer_OnLoadComplete()
        await self.IHaveCBOCalculator_OnLoadComplete()
        await self.OnIHaveCBOInputsLoaded
        await self.IHaveSpendMetrics_OnLoadComplete()

        let inputMain = _.filter(self.WB_CBO.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, aRow => aRow.isActive && aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE.toLowerCase() == 'forwardbuy')

        if (inputMain.length)
            this.forwardBuy = inputMain[0].WB_SimulationInputRow.cif.SIMULATION_INPUT_ID
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.drWB_CBO.cif.CBO_NAME + "(" + self.drWB_CBO.cif.CBO_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate CBO.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }
            ConstraintBasedOptimizerBOValidation.Validation(self)
                .then((ignore) => {
                    self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
                    self.ValidateProgressProvider.finish();
                    resolve(self);

                })
                .catch((err) => {
                    self._bIsValidated = false;
                    self.ValidateProgressProvider.exception(err);
                    resolve(self);

                })
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;

        this.SaveProgressProvider.start("Saving " + self.WB_CBO.cif.CBO_NAME + "(" + self.WB_CBO.cif.CBO_ID + ")");

        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save CBO";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            let bDone = false
            if (!_.isEmpty(self.forwardBuy)){
                _.forEach(self.drWB_CBO.WB_CBOInputRelationshipRows, anInput=>{
                    anInput.cif[self.forwardBuy] = self.WB_CBO.cif.CNS_FORWARD_BUY_PCNT
                })
            }

            self.Validate({})
                .then((ignore) => {
                    if (!self.bIsValidated) {
                        self._bIsSaved = false;
                        bDone = true;
                        self.SaveProgressProvider.finish();
                        resolve(self);
                        return;
                    }
                    return saveFunction(esWB_CBO, self.drWB_CBO, {})
                        .then(() => {
                            let tasks: Promise<any>[] = []
                            tasks.push(saveFunction(esWB_CBO_Input_Relationship, self.drWB_CBO.WB_CBOInputRelationshipRows))
                            tasks.push(saveFunction(esWB_CBO_Predictor_Relationship, self.drWB_CBO.WB_CBOPredictorRelationshipRows))
                            tasks.push(saveFunction(esWB_CBO_Predictor_Range, self.drWB_CBO.WB_CBOPredictorRangeRows))
                            tasks.push(saveFunction(esWB_CBO_Product, self.drWB_CBO.WB_CBOProductRows))
                            tasks.push(saveFunction(esWB_CBO_Predictor_DiscreteSet, self.drWB_CBO.WB_CBOPredictorDiscreteSetRows))
                            tasks.push(saveFunction(esWB_CBO_Constraint, self.drWB_CBO.WB_CBOConstraintRows))
                            tasks.push(saveFunction(esWB_Spend_Function_Relationship, self.drWB_CBO.WB_SpendFunctionXrefRows))
                            return Promise.all(tasks)
                        })
                        .then((ignored) => {
                            if (bBatch) {
                                self.dbContext.addBatchCompleteListener(() => {
                                    self._bIsSaved = true;
                                })
                            } else {
                                self._bIsSaved = true;
                            }
                            self.SaveProgressProvider.finish();
                            resolve(self);
                        })
                        .catch((err) => {
                            self.SaveProgressProvider.exception(err);
                            reject(self);
                        })
                })


        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + self.drWB_CBO.cif.CBO_NAME + "(" + self.drWB_CBO.cif.CBO_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_CBO.WB_CBOInputRelationshipRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_CBO.WB_CBOPredictorRelationshipRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_CBO.WB_CBOPredictorRangeRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_CBO.WB_CBOProductRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_CBO.WB_CBOMetricRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            _.forEach(self.drWB_CBO.WB_CBOConstraintRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })

            _.forEach(self.drWB_CBO.WB_SpendFunctionXrefRows, (aRow) => {
                if (aRow.isActive) {
                    aRow.markDeleted()
                }
            })
            self.drWB_CBO.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }


    //</editor-fold>

    //<editor-fold desc = "IHaveRefCounter">
    private _refCounter: IRefCounter
    private _refCounterSub: Subscription

    RefCounter_Init(): void {
        this._refCounter = new RefCounter(this)
        this._refCounterSub = this.RefCounter.OnRefCounterChanged.subscribe(this.onRefCounterChanged.bind(this))
    }

    get RefCounter(): IRefCounter {
        return this._refCounter
    }

    private onRefCounterChanged(event: { refCounter: IRefCounter, count: number }): void {
        if (this.RefCounter.RefCount > 0)
            return

        if (_.isEmpty(this._cboCalculator))
            return

        this._cboCalculator.StopStatusLoop()

    }

    //</editor-fold>


    //<editor-fold desc = "Record Resolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const CBO_options: CreateOptions = {
            standardConditions: {
                [esWB_Simulation_Type]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Type_Input_Relationship]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Simulation_Input]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Published_Model]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Predictor_Relationship]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Predictor_Range]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Input_Relationship]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Product]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Metric]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Metric_Predictor]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Constraint]: {"DELETED_IND": {"notIn": ['1']}}
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Simulation_Type]: [esWB_Simulation_Type_Input_Relationship],
                [esWB_Published_Model]: [esWB_User]
            }
        };

        return new ESRecordResolver(dbContext, CBO_options);
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_CBO, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //<editor-fold desc = "BO operations">

    addRangeRow(aPredictRow: WB_ModelPredictorRow): Promise<IBusinessObject> {
        let self = this
        return new Promise<IBusinessObject>((resolve, error) => {
            self.dbContext.createRecordWithKey(esWB_CBO_Predictor_Range)
                .then((newRecord: WB_CBOPredictorRangeRow) => {
                    newRecord.setDefaults()
                    newRecord.cif.WB_CBO_ID = self.drWB_CBO.cif.WB_CBO_ID
                    newRecord.cif.WB_MODEL_PREDICTOR_ID = aPredictRow.cif.WB_MODEL_PREDICTOR_ID
                    newRecord.WB_CBORow = self.drWB_CBO
                    newRecord.WB_ModelPredictorRow = aPredictRow
                    self.dbContext.add(esWB_CBO_Predictor_Range, newRecord)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    async createOrGetMetricConstraints(arrMetricIds: string[]): Promise<WB_CBOConstraintRow[]> {
        const self = this
        let returnValue: WB_CBOConstraintRow[] = []

        let dctByMetricId: { [metricId: string]: WB_CBOConstraintRow } = {}
        _.forEach(self.WB_CBO.WB_CBOConstraintRows, (aRow) => {
            if (!aRow.isActive)
                return
            if (aRow.cif.METRIC_ID in dctByMetricId) {
                aRow.markDeleted()
                return
            }

            dctByMetricId[aRow.cif.METRIC_ID] = aRow

        })

        for (let aMetricId of arrMetricIds) {
            if (aMetricId in dctByMetricId) {
                returnValue.push(dctByMetricId[aMetricId])
                continue
            }

            let aNewRow = <WB_CBOConstraintRow>await self.dbContext.createRecordWithKey(esWB_CBO_Constraint)
            aNewRow.setDefaults()
            aNewRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID
            aNewRow.cif.METRIC_ID = aMetricId
            aNewRow.cif.ACTIVE_IND = '0'
            aNewRow.cif.MIN_VALUE = undefined
            aNewRow.cif.MIN_VALUE = undefined
            self.dbContext.add(esWB_CBO_Constraint, aNewRow)
            returnValue.push(aNewRow)
        }

        return returnValue
    }

    //</editor-fold>


    //<editor-fold desc = "IHaveProductGroup operations">

    _bIHaveProductGroupsLoaded: boolean;
    _OnIHaveProductGroupsLoaded: Promise<IHaveProductGroups>;
    _ProductGroupsAll: WB_ProductGroupRow[]

    IHaveProductGroups_init() {
        this.ProductGroupsChanged = new BehaviorSubject<IHaveProductGroups>(this)
        this._bIHaveProductGroupsLoaded = false
        this._OnIHaveProductGroupsLoaded = undefined
        this._ProductGroupsAll = []
    }


    ProductGroupsChanged: BehaviorSubject<IHaveProductGroups>;

    get bIHaveProductGroupsLoaded(): boolean {
        return this._bIHaveProductGroupsLoaded
    }

    get OnIHaveProductGroupsLoaded(): Promise<IHaveProductGroups> {

        const self = this;

        if (self.bIHaveProductGroupsLoaded) {
            return ASync.resolve(self)
        }

        if (!_.isEmpty(self._OnIHaveProductGroupsLoaded))
            return self._OnIHaveProductGroupsLoaded; // Load already started, wait on same Promise

        let OnLoadPromise = new Promise<IHaveProductGroups>((resolve, error) => {
            // If the BO is not loaded, throw an error.. It should have been started
            // if ((!(self.bIsLoaded)) && (_.isEmpty(self.OnLoadComplete))) {
            //     error("CBO isn't Loaded or Loading.. Can't determine Product Groups");
            //     return;
            // }

            let boLoadPromise
            if (self.bIsLoaded) {
                boLoadPromise = ASync.resolve(self)
            } else {
                boLoadPromise = self.OnLoadComplete
            }
            boLoadPromise
                .then(() => {
                    let arrWbPrdGrp = _.uniq(_.map(this.ModelCoefficientSet.WB_ModelCoefficientSet.WB_ModelCoefficientSetRRows, aXrefRow => {
                        return aXrefRow.WB_ProductGroupRow
                    }))
                    self._ProductGroupsAll = arrWbPrdGrp
                    this._bIHaveProductGroupsLoaded = true;
                    this._OnIHaveProductGroupsLoaded = undefined

                    resolve(self);

                })
                .catch((err) => {
                    error(err)
                })


        });


        self._OnIHaveProductGroupsLoaded = OnLoadPromise
        return OnLoadPromise;
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        return _.map(_.filter(this.WB_CBO.WB_CBOProductRows, (aRow) => aRow.isActive), (aRow) => aRow.WB_ProductGroupRow)
    }

    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._ProductGroupsAll
    }

    get ProductGroupsReadOnly(): boolean {

        // TODO: Check Security Roles..
        return false;
    }

    addProductGroups(arrProductGroupId: number[]): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            self.dbContext.findUsingCache(esWB_Product_Group, arrProductGroupId)
                .then((arrPrdGrpRows: WB_ProductGroupRow[]) => {

                    async function createProductGroupRows() {
                        for (let idx in arrPrdGrpRows) {
                            let aWB_PrdGrpRow = arrPrdGrpRows[idx]
                            let newRecord: WB_PlanProductGroupRow = <any>await self.dbContext.createRecordWithKey(esWB_CBO_Product)
                            newRecord.setDefaults()
                            newRecord.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID
                            newRecord.cif.WB_PRDGRP_ID = aWB_PrdGrpRow.cif.WB_PRDGRP_ID
                            newRecord.WB_ProductGroupRow = aWB_PrdGrpRow
                            self.dbContext.add(esWB_CBO_Product, newRecord)
                        }
                        self.ProductGroupsChanged.next(self)
                        await self.SyncProductGroups()
                    }

                    return createProductGroupRows()
                })
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    addCBOCustomer(record: any): Promise<ConstraintBasedOptimizerBO> {
        const self = this;
        return new Promise<ConstraintBasedOptimizerBO>((resolve, error) => {

            let aFinishedProductRow: WB_CustomerRow = undefined

            // Is the product in the product table?
            self.dbContext.find(esWB_Customer, record)
                .then((aFinishedProductRecord: WB_CustomerRow) => {
                    if (_.isEmpty(aFinishedProductRecord)) {
                        // Bad Customer ID
                        resolve(self)
                        return
                    }
                    aFinishedProductRow = aFinishedProductRecord

                    // create new records
                    self.drWB_CBO.cif.WB_CUST_ID = aFinishedProductRow.cif.WB_CUST_ID
                    resolve(self)
                })

        })
    }


    addProductGroup(ProductGroupId: number): Promise<void> {
        const self = this

        return self.addProductGroups([ProductGroupId])
    }

    removeProductGroups(arrProductGroupId: number[]): Promise<void> {
        const self = this

        return new Promise<void>(async (resolve, error) => {
            let bChanged = false
            _.forEach(self.WB_CBO.WB_CBOProductRows, (aRow) => {
                if (aRow.isActive && _.includes(arrProductGroupId, aRow.cif.WB_PRDGRP_ID)) {
                    bChanged = true
                    aRow.markDeleted()
                }
            })

            if (bChanged) {
                self.ProductGroupsChanged.next(self)
                await self.SyncProductGroups()
            }

            resolve()

        })
    }

    removeProductGroup(ProductGroupId: number): Promise<void> {
        const self = this

        return self.removeProductGroups([ProductGroupId])
    }

    hasProductGroup(ProductGroupId: number): boolean {
        const self = this
        let returnValue = false

        _.forEach(self.WB_CBO.WB_CBOProductRows, (aRow) => {
            if (aRow.isActive && aRow.cif.WB_PRDGRP_ID == ProductGroupId) {
                returnValue = true
                return false // stop iterating
            }
        })

        return returnValue
    }

    isProductGroupEditable(ProductGroupId: number): boolean {
        return true;
    }

//</editor-fold>

    //<editor-fold desc="IHaveModel Operations">

    private _Model: ModelBO;
    private _OnIHaveModelLoaded: Promise<void>;
    private _bIHaveModelLoaded: boolean;

    IHaveModel_init() {
        this._bIHaveModelLoaded = false
        this._OnIHaveModelLoaded = undefined
        this._Model = undefined
    }

    get bIHaveModelLoaded(): boolean {
        return this._bIHaveModelLoaded
    }

    get OnIHaveModelLoaded(): Promise<void> {
        const self = this

        if (self._OnIHaveModelLoaded)
            return self._OnIHaveModelLoaded

        let returnValue = self._OnIHaveModelLoaded = new Promise<void>((resolve, error) => {
            let wbModelId = self.WB_CBO.WB_PublishedModelRow.cif.WB_MODEL_ID
            if (!(wbModelId > 0)) {
                error(`No Model Specified: ${wbModelId}`)
                return
            }
            let aModel = new ModelBO()
            aModel.Load(wbModelId, {dbContext: self.dbContext})
                .then((ignore) => {
                    self._Model = aModel
                    self._bIHaveModelLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

        return returnValue
    }

    get Model(): ModelBO {
        return this._Model
    }

//</editor-fold>

    //<editor-fold desc="IHaveModelCoefficientSet Operations">

    private _modelCoefficientSet: ModelCoefficientSetBO;
    private _OnIHaveModelCoefficientSetLoaded: Promise<void>;
    private _bIHaveModelCoefficientSetLoaded: boolean;

    IHaveModelCoefficientSet_init() {
        this._bIHaveModelCoefficientSetLoaded = false
        this._OnIHaveModelCoefficientSetLoaded = undefined
        this._modelCoefficientSet = undefined
    }

    get bIHaveModelCoefficientSetLoaded(): boolean {
        return this._bIHaveModelCoefficientSetLoaded
    }

    get OnIHaveModelCoefficientSetLoaded(): Promise<void> {
        const self = this

        if (self._OnIHaveModelCoefficientSetLoaded)
            return self._OnIHaveModelCoefficientSetLoaded

        let returnValue = self._OnIHaveModelCoefficientSetLoaded = new Promise<void>((resolve, error) => {
            let wbModelCoefficientSetId = self.WB_CBO.WB_PublishedModelRow.cif.WB_MODEL_COEFF_SET_ID
            if (!(wbModelCoefficientSetId > 0)) {
                error(`No Coeff Set Specified: ${wbModelCoefficientSetId}`)
                return
            }
            let aModelCoefficientSet = new ModelCoefficientSetBO()
            aModelCoefficientSet.Load(wbModelCoefficientSetId, {dbContext: self.dbContext})
                .then((ignore) => {
                    self._modelCoefficientSet = aModelCoefficientSet
                    self._bIHaveModelCoefficientSetLoaded = true
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })

        return returnValue
    }

    get ModelCoefficientSet(): ModelCoefficientSetBO {
        return this._modelCoefficientSet
    }

//</editor-fold>

    //<editor-fold desc="IHaveSimulationCalculator operations">

    private _cboCalculator: CBOCalculator;


    private IHaveCBOCalculator_init() {
        this._cboCalculator = new CBOCalculator()
    }

    private IHaveCBOCalculator_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self._cboCalculator.Register(self)
            resolve()
        })

    }


    get CBOCalculator(): ICBOCalculator {
        return this._cboCalculator
    }

    private _solverMessageProvider: MessageProvider
    private _solverProgressProvider: ProgressProvider

    private ICBOSolver_init() {
        this._solverProgressProvider = new ProgressProvider("CBOSolve")
        this._solverMessageProvider = new MessageProvider();
        // this._solverTrialsChanged = new BehaviorSubject<ModelingSessionBO>(this);
    }

    get CBOSolverProgressProvider(): IProgressProvider {
        return this._solverProgressProvider
    }

    get CBOSolverMessageProvider(): IMessageProvider {
        return this._solverMessageProvider
    }

    CBOCalculatorOnSolvePress() {
        const self = this
        self.ValidateMessageProvider.clearMessages();
        return new Promise((resolve, reject)=> {
            self.CBOSolverProgressProvider.start("CBOSolving")
            let userContext: WB_UserRow = PAEnvironment.getValue(PAEnvironment.UserContext);

            self.CBOCalculator.Calculate({wbAuthUsrId: userContext.User.cif.WB_AUTHUSR_ID})
                .then((data) => {
                    const e = {name: 'CBOCalcSuccess', message: 'CBOCalculation Completed'}
                    self.CBOSolverProgressProvider.finish()
                    self.CBOSolverMessageProvider.addMessage({
                        code: 'CBOCalcSuccess',
                        type: MessageType.Information,
                        title: `${e.message}`,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
                resolve()
                })
                .catch(() => {
                    const e = {name: 'CBOCalcError', message: 'CBOCalculation failed'}
                    self.CBOSolverProgressProvider.exception(e)
                    self.CBOSolverMessageProvider.addMessage({
                        code: 'CalcError',
                        type: MessageType.Error,
                        title: "Error in solving the CBO Solve",
                        description: `${e.message}`,
                        subtitle: "",
                        count: 0
                    })
                    reject()
                })
        })

    }

//</editor-fold>


    private _DiscreteSetPropertyChanged: BehaviorSubject<DiscreteSetChangeEvent>;
    private _DiscreteSetCollectionChanged: BehaviorSubject<IConstraintBasedOptimizer>;

    private IConstraintBasedOptimizer_init() {

        this._DiscreteSetPropertyChanged = new BehaviorSubject<DiscreteSetChangeEvent>(undefined)
        this._DiscreteSetCollectionChanged = new BehaviorSubject<IConstraintBasedOptimizer>(undefined)
    }

    private IConstraintBasedOptimizer_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {


            _.forEach(self.WB_CBO.WB_CBOPredictorDiscreteSetRows, (aRow) => {
                if (!aRow.isActive) {
                    return
                }
                aRow.setupOnChangeEvents([], self.IConstraintBasedOptimizer_onDiscreteSetRecordChange.bind(self), self)

            })


            resolve()
        })
    }

    private IConstraintBasedOptimizer_onDiscreteSetRecordChange(record: WB_CBOPredictorDiscreteSetRow, propertyName: string, propertyValue: any, options: ConstraintBasedOptimizerBO) {
        this.onDiscreteSetPropertyChanged.next({
            "ConstraintBasedOptimizerBO": options,
            Row: record,
            PropertyChanged: propertyName,
            PropertyValue: propertyValue
        })
    }


    get onDiscreteSetCollectionChanged(): BehaviorSubject<IConstraintBasedOptimizer> {
        return this._DiscreteSetCollectionChanged
    }

    get onDiscreteSetPropertyChanged(): BehaviorSubject<DiscreteSetChangeEvent> {
        return this._DiscreteSetPropertyChanged
    }

    //<editor-fold desc = "App DiscreteSet Operations">

    addDiscreteSet(groupName: string): Promise<WB_CBOPredictorDiscreteSetRow> {
        const self = this

        return new Promise<WB_CBOPredictorDiscreteSetRow>((resolve, error) => {

            // first find out if record exists.
            let found = false

            return self.dbContext.createRecordWithKey(esWB_CBO_Predictor_DiscreteSet)
                .then((aNewRow: WB_CBOPredictorDiscreteSetRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID
                    aNewRow.cif.GROUP_NAME = groupName
                    aNewRow.cif.SET_ID = _.filter(self.WB_CBO.WB_CBOPredictorDiscreteSetRows, aSet => aSet.isActive && aSet.cif.GROUP_NAME == groupName).length + 1
                    self.dbContext.add(esWB_CBO_Predictor_DiscreteSet, aNewRow)

                    aNewRow.setupOnChangeEvents([], self.IConstraintBasedOptimizer_onDiscreteSetRecordChange.bind(self), self)
                    self.onDiscreteSetCollectionChanged.next(self)
                    resolve(aNewRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }


    removeDiscreteSet(aDiscreteSetId: number): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            let groupName: string = ""
            _.forEach(self.drWB_CBO.WB_CBOPredictorDiscreteSetRows, (anDiscreteSetRow: WB_CBOPredictorDiscreteSetRow) => {
                if (anDiscreteSetRow.isActive && anDiscreteSetRow.cif.WB_CBO_PREDICTORDS_ID == aDiscreteSetId) {
                    groupName = anDiscreteSetRow.cif.GROUP_NAME
                    anDiscreteSetRow.markDeleted()
                }
            })
            _.forEach(_.sortBy(_.filter(self.drWB_CBO.WB_CBOPredictorDiscreteSetRows, aRow => aRow.isActive && aRow.cif.GROUP_NAME == groupName), ['SET_ID'], ['asc']), (anDiscreteSetRow, idx) => {

                anDiscreteSetRow.cif.SET_ID = idx + 1

            })
            self.onDiscreteSetCollectionChanged.next(self)
            resolve()
        })
    }

    get DiscreteSets(): WB_CBOPredictorDiscreteSetRow[] {
        return _.orderBy(this.WB_CBO.WB_CBOPredictorDiscreteSetRows, ['SET_ID'], ['asc'])
    }

    //</editor-fold>
    //</editor-fold>

    //<editor-fold desc="Reload">

    async ReloadMetrics(): Promise<void> {
        const self = this

        self.dbContext.purgeCache(esWB_CBO_Metric, self.WB_CBO.WB_CBOMetricRows)
        let rr = new ESRecordResolver(self.dbContext, {
            standardConditions: {
                [esWB_CBO_Metric]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_CBO_Metric_Predictor]: {"DELETED_IND": {"notIn": ['1']}}
            }
        })

        await rr.queryAllWithRelationships(esWB_CBO_Metric, {
            where: {
                WB_CBO_ID: self.WB_CBO?.cif.WB_CBO_ID,
                DELETED_IND: {"notIn": ['1']}
            }
        })

    }

    //</editor-fold>


    //<editor-fold desc="CustomerList">

    CBOcustomerList(): Promise<WB_CustomerRow[]> {
        const self = this
        let modelRow = undefined
        return new Promise((resolve, reject) => {
            let publishedModelId = self.drWB_CBO.cif.WB_PUBLISHED_MODEL_ID
            self.dbContext.find(esWB_Published_Model, publishedModelId)
                .then((aPublishModelRecord: WB_Published_ModelRow) => {
                    if (_.isEmpty(aPublishModelRecord))
                        return
                    let modCoeffSetRIds = aPublishModelRecord.cif.WB_MODEL_COEFF_SET_ID
                    return self.dbContext.findAll(esWB_Model_Coeff_SetR, {where: {WB_MODEL_COEFF_SET_ID: {in: [modCoeffSetRIds]}}})
                })
                .then((aModelCoeffSetRs: WB_ModelCoefficientSetRRow) => {
                    if (_.isEmpty(aModelCoeffSetRs))
                        return
                    let customerIds = _.map(aModelCoeffSetRs, (modCoeffSetR: WB_ModelCoefficientSetRRow) => {
                        return modCoeffSetR.cif.WB_CUST_ID
                    })
                    return self.dbContext.findAll(esWB_Customer, {where: {WB_CUST_ID: {in: customerIds}}})
                })
                .then((customerRows: WB_CustomerRow[]) => {
                    resolve(customerRows)
                })

        })

    }

    //</editor-fold>

    //<editor-fold desc="Spend Function ">
    private _metricTypes: string[]
    private _spendMetrics: { key: number, text: string }[]

    private IHaveSpendMetrics_init() {
        this._metricTypes = []
        this._spendMetrics = []
    }


    private IHaveSpendMetrics_OnLoadComplete(): Promise<void> {
        this._metricTypes = _.uniq(_.concat(_.map(_.filter(this.Model.WB_Model.WB_ModelPredictorRelationshipRows, aRow => aRow.cif.DELETED_IND != '1'), aRel => {
                return aRel.WB_ModelPredictorRow.cif.PREDICTOR_META_ID
            }),
            _.map(_.filter(this.WB_CBO.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, aRow => aRow.cif.DELETED_IND != '1'), aRel => {
                return aRel.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE
            })))

        this._spendMetrics = _.map(_.filter(this.WB_CBO.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, aRow => aRow.cif.PLACEMENT.toLowerCase() == 'spend' && aRow.cif.DELETED_IND != '1'), aRel => {
            return {
                key: aRel.WB_SimulationInputRow.cif.WB_SIMULATION_INPUT_ID,
                text: aRel.WB_SimulationInputRow.cif.SIMULATION_INPUT_NAME
            }
        })
        return

    }


    addSpendFunction(aSpendInputId: number): Promise<WB_SpendFunctionRelationshipRow> {
        const self = this
        return new Promise<WB_SpendFunctionRelationshipRow>((resolve, error) => {
            // first find out if record exists.
            let anInputRecord: WB_SimulationInputRow = undefined
            self.dbContext.find(esWB_Simulation_Input, aSpendInputId)
                .then((anInputRow: WB_SimulationInputRow) => {
                    if (anInputRow)
                        anInputRecord = anInputRow

                    return self.dbContext.createRecordWithKey(esWB_Spend_Function_Relationship)
                })
                .then((aNewRow: WB_SpendFunctionRelationshipRow) => {
                    aNewRow.setDefaults()
                    aNewRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID
                    aNewRow.WB_CBORow = self.WB_CBO
                    aNewRow.cif.WB_SIMULATION_INPUT_ID = anInputRecord.cif.WB_SIMULATION_INPUT_ID
                    aNewRow.WB_SimulationInputRow = anInputRecord
                    self.dbContext.add(esWB_CBO_Predictor_DiscreteSet, aNewRow)
                    resolve(aNewRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeSpendFunction(aSpendFunctionId: number): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            let groupName: string = ""
            _.forEach(self.drWB_CBO.WB_SpendFunctionXrefRows, (aSpendFunctionXrefRow: WB_SpendFunctionRelationshipRow) => {
                if (aSpendFunctionXrefRow.isActive && aSpendFunctionXrefRow.cif.WB_SPEND_FUNCTIONR_ID == aSpendFunctionId) {
                    aSpendFunctionXrefRow.markDeleted()
                }
            })
            resolve()
        })
    }

    get AllMetricTypes(): string[] {
        return this._metricTypes
    }

    get SpendMetrics(): { key: number, text: string }[] {
        return this._spendMetrics
    }

    get SpendFunctionRows(): WB_SpendFunctionRelationshipRow[] {
        return this.WB_CBO.WB_SpendFunctionXrefRows
    }

    //</editor-fold>

    //<editor-fold desc="Constant and Input operations ">
    private _bIHaveCBOInputsLoaded: boolean
    private _OnIHaveCBOInputsLoaded: Promise<void>
    private _CBOConstantInputsProgressProvider: ProgressProvider
    private _OnCBOInputsCollectionChanged: BehaviorSubject<IHaveCBOConstantInputs>
    private _CBOInputs_ProductGroups: WB_ProductGroupRow[];
    private _CBOConstant_ProductGroups: WB_ProductGroupRow[];
    private _CBOPredictors: WB_CBOPredictorRelationshipRow[];
    private _CBOInputs: WB_CBOInputRelationshipRow[];


    IHaveCBOInputs_init() {
        this._bIHaveCBOInputsLoaded = false
        this._OnCBOInputsCollectionChanged = new BehaviorSubject<IHaveCBOConstantInputs>(undefined)
        this._CBOConstantInputsProgressProvider = new ProgressProvider()
        this._CBOInputs_ProductGroups = [];
        this._CBOConstant_ProductGroups = [];
    }


    get bIHaveCBOInputsLoaded(): boolean {
        return this._bIHaveCBOInputsLoaded
    }

    get OnIHaveCBOInputsLoaded(): Promise<void> {
        const self = this

        if (self._bIHaveCBOInputsLoaded) {
            return ASync.resolve()
        }

        if (!_.isEmpty(self._OnIHaveCBOInputsLoaded)) {
            return self._OnIHaveCBOInputsLoaded
        }
        let returnValue = new Promise<void>((resolve, error) => {
            let bDone = false
            self.SyncProductGroups()
                .then((ignore) => {
                    if (bDone) {
                        return
                    }
                    self._OnIHaveCBOInputsLoaded = undefined
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
        self._OnIHaveCBOInputsLoaded = returnValue
        return returnValue
    }

    get OnCBOInputsCollectionChanged(): BehaviorSubject<IHaveCBOConstantInputs> {
        return this._OnCBOInputsCollectionChanged
    }


    get CBOPredictors(): WB_CBOPredictorRelationshipRow[] {
        return this.WB_CBO.WB_CBOPredictorRelationshipRows
    }

    get CBOInputs(): WB_CBOInputRelationshipRow[] {
        return this.WB_CBO.WB_CBOInputRelationshipRows
    }

    get CBOInputs_ProductGroups(): WB_ProductGroupRow[] {
        return this._CBOInputs_ProductGroups
    }

    get CBOConstant_ProductGroups(): WB_ProductGroupRow[] {
        return this._CBOConstant_ProductGroups
    }

    get CBOConstantInputsProgressProvider(): IProgressProvider {
        return this._CBOConstantInputsProgressProvider
    }


    async SyncProductGroups(): Promise<void> {
        const self = this

        let dctPrdGrps = _.keyBy(_.filter(self.WB_CBO.WB_CBOProductRows, (a) => a.isActive), (a) => a.cif.WB_PRDGRP_ID)
        let dctInputPrdGrps = _.keyBy(_.filter(self.WB_CBO.WB_CBOInputRelationshipRows, (a) => a.isActive), (a) => a.cif.WB_PRDGRP_ID)
        let dctConstantPrdGrps = _.keyBy(_.filter(self.WB_CBO.WB_CBOPredictorRelationshipRows, (a) => a.isActive), (a) => a.cif.WB_PRDGRP_ID)

        // Add Missing
        _.forEach(_.values(dctPrdGrps), async (aRow) => {
            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID

            if (!(wbPrdGrpId in dctConstantPrdGrps)) {
                let newRow: WB_CBOPredictorRelationshipRow = <any>await self.dbContext.createRecordWithKey(esWB_CBO_Predictor_Relationship)
                newRow.setDefaults()
                newRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID
                newRow.WB_CBORow = self.WB_CBO
                newRow.cif.WB_PRDGRP_ID = wbPrdGrpId
                newRow.WB_ProductGroupRow = aRow.WB_ProductGroupRow
                self.dbContext.add(esWB_CBO_Predictor_Relationship, newRow)
            }

            if (!(wbPrdGrpId in dctInputPrdGrps)) {
                let newRow: WB_CBOInputRelationshipRow = <any>await self.dbContext.createRecordWithKey(esWB_CBO_Input_Relationship)
                newRow.setDefaults()
                newRow.cif.WB_CBO_ID = self.WB_CBO.cif.WB_CBO_ID
                newRow.WB_CBORow = self.WB_CBO
                newRow.cif.WB_PRDGRP_ID = wbPrdGrpId
                newRow.WB_ProductGroupRow = aRow.WB_ProductGroupRow
                self.dbContext.add(esWB_CBO_Input_Relationship, newRow)
            }
        })

        // Remove Extra
        //-- Predictors
        _.forEach(self.WB_CBO.WB_CBOPredictorRelationshipRows, (aRow) => {
            if (!aRow.isActive)
                return
            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            if (!(wbPrdGrpId in dctPrdGrps))
                aRow.markDeleted()
        })

        //-- Inputs
        _.forEach(self.WB_CBO.WB_CBOInputRelationshipRows, (aRow) => {
            if (!aRow.isActive)
                return
            let wbPrdGrpId = aRow.cif.WB_PRDGRP_ID
            if (!(wbPrdGrpId in dctPrdGrps))
                aRow.markDeleted()
        })

        self.OnCBOInputsCollectionChanged.next(self)

    }

    async updatePricing(): Promise<void> {
        let self = this
        let wbPricingEngineID = self.WB_CBO.WB_SimulationTypeRow.WB_BusinessUnitRow.cif.WB_PRICINGENGINE_ID
        let arrInput: { [id: string]: string } = {}


        if (_.isEmpty(self.forwardBuy)) {
            self.WB_CBO.cif.CNS_FORWARD_BUY_PCNT = 0
        }
        _.forEach(self.WB_CBO.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, aRow => {
            if (!_.isEmpty(aRow.WB_SimulationInputRow) && _.includes(['COGS','VCM', 'NetListPrice', 'GrossListPrice', 'FundingRate'], aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE)) {
                if (!_.isEmpty(arrInput[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE]))
                    arrInput[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE] += ","
                arrInput[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE] = aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_ID
            }

        })

        for (let i = 0; i < self.WB_CBO.WB_CBOProductRows.length; i++) {
            let aPG = self.WB_CBO.WB_CBOProductRows[i]

            let aNetListPriceCondition: IwbProductCondition = undefined
            if ('NetListPrice' in arrInput) {
                aNetListPriceCondition = await PricingEngine.getCustomerNetListPrice(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_CBO.cif.WB_CUST_ID,
                    0,
                    self.WB_CBO.StartDate,
                    self.WB_CBO.EndDate)
            }

            let aGrossListPriceCondition: IwbProductCondition = undefined
            if ('GrossListPrice' in arrInput) {
                aGrossListPriceCondition = await PricingEngine.getCustomerListPrice(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_CBO.cif.WB_CUST_ID,
                    0,
                    self.WB_CBO.StartDate,
                    self.WB_CBO.EndDate)
            }

            let aVMCCondition: IwbProductCondition = undefined
            if ('VCM' in arrInput) {
                aVMCCondition = await PricingEngine.getCustomerVCM(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_CBO.cif.WB_CUST_ID,
                    0,
                    self.WB_CBO.StartDate,
                    self.WB_CBO.EndDate)

            }

            let aCOGSCondition: IwbProductCondition = undefined
            if ('COGS' in arrInput) {

                aCOGSCondition = await PricingEngine.getCustomerCOGS(
                    wbPricingEngineID,
                    aPG.cif.WB_PRDGRP_ID,
                    self.WB_CBO.cif.WB_CUST_ID,
                    0,
                    self.WB_CBO.StartDate,
                    self.WB_CBO.EndDate)

            }

            let arrFundingRate: { [id: string]: IwbProductCondition } = {}
            if ('FundingRate' in arrInput) {
                _.forEach(_.filter(self.WB_CBO.WB_SimulationTypeRow.WB_SimulationTypeInputRelationshipRows, aRow => aRow.isActive && aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_TYPE == "FundingRate"), async aRow => {
                    let aRate = await PricingEngine.getPrdGrpFundingRateTotal(
                        aPG.cif.WB_PRDGRP_ID,
                        self.WB_CBO.cif.WB_CUST_ID,
                        aRow.WB_SimulationInputRow.cif.WB_FUNDTYPE_ID,
                        0,
                        0,
                        aRow.WB_SimulationInputRow.cif.PRD_CNDM_ID_STD,
                        aRow.WB_SimulationInputRow.cif.PRD_CNDM_ID_ADDL,
                        self.WB_CBO.StartDate,
                        self.WB_CBO.EndDate)
                    arrFundingRate[aRow.WB_SimulationInputRow.cif.SIMULATION_INPUT_ID] = aRate
                })
            }

            _.forEach(_.filter(self.WB_CBO.WB_CBOInputRelationshipRows, aRow => aRow.cif.WB_PRDGRP_ID == aPG.cif.WB_PRDGRP_ID), anInputRow => {
                if (!_.isEmpty(aNetListPriceCondition))
                    anInputRow.cif[arrInput['NetListPrice']] = aNetListPriceCondition.VALUE_RATEAMOUNT
                if (!_.isEmpty(aGrossListPriceCondition))
                    anInputRow.cif[arrInput['GrossListPrice']] = aGrossListPriceCondition.VALUE_RATEAMOUNT
                if (!_.isEmpty(aVMCCondition))
                    anInputRow.cif[arrInput['VCM']] = aVMCCondition.VALUE_RATEAMOUNT
                if (!_.isEmpty(aCOGSCondition))
                    anInputRow.cif[arrInput['COGS']] = aCOGSCondition.VALUE_RATEAMOUNT

                if (!_.isEmpty(arrFundingRate))
                    _.forEach(arrInput['FundingRate'].split(","), anInput => {
                        anInputRow.cif[anInput] = arrFundingRate[anInput].VALUE_RATEAMOUNT
                    })

                if (!_.isEmpty(self.forwardBuy)) {
                    if (self.forwardBuy in anInputRow) {
                        anInputRow.cif[self.forwardBuy] = self.WB_CBO.cif.CNS_FORWARD_BUY_PCNT
                    }
                }
            })
        }

        return
    }

    getStartDayCount(): number {
        const self = this
        let rows = []
        //Number of start dates
        let startDate = DateUtils.convertFromSAPBW(self.WB_CBO.cif.START_DT)
        let endDate = DateUtils.convertFromSAPBW(self.WB_CBO.cif.END_DT)
        return self.countStartDate(startDate, endDate)

    }

    countStartDate(start: any, end: any): number {
        if (end < start) return; //avoid infinite loop;
        let count: number = 0
        for (count; start <= end; start.setDate(start.getDate() + 1)) {
            if (start.getDay() == 5) count++;
        }
        return count;
    }


    //</editor-fold>

}

PAEnvironment.registerBusinessObjectClass(ConstraintBasedOptimizerBO, "ConstraintBasedOptimizerBO", "Constraint Based Optimizer")